/* eslint-disable */
if (process.env.NODE_ENV === 'production') {
    if (process.env.AFFIXE2_ENV === 'staging') {
        module.exports = require('./config.staging');
    } else if (process.env.AFFIXE2_ENV === 'ci') {
        module.exports = require('./config.ci');
    } else {
        module.exports = require('./config.prod');
    }
} else {
    module.exports = require('./config.dev');
}
//module.exports = require('./config.staging');



// WEBPACK FOOTER //
// ./src/api/config/config.js